/**
 * Legacy URL slugs that must keep resolving after a workspace slug rename.
 * Storage keys (content_root, documents.file_path) stay put.
 *
 * Keep in sync with scripts/utils/workspace-slug-aliases.js.
 */

export const PRODUCT_CONTENT_ROOT = 'flownotes-app-docs'
export const LEGACY_PRODUCT_SLUGS = ['flownotes-product']

type AliasWorkspace = {
  slug?: string | null
  contentRoot?: string | null
  content_root?: string | null
  slugAliases?: string[] | null
}

function normalizeContentRoot(root: string): string {
  return root.replace(/^\/+/, '').replace(/\/+$/, '')
}

/** Slugs that are not the workspace's current slug but must still match its URLs. */
export function slugAliasesForWorkspace(workspace: AliasWorkspace): string[] {
  const current = (workspace.slug || '').trim().toLowerCase()
  const root = normalizeContentRoot(workspace.contentRoot || workspace.content_root || '')
  const aliases: string[] = []
  if (root === PRODUCT_CONTENT_ROOT) aliases.push(...LEGACY_PRODUCT_SLUGS)
  if (Array.isArray(workspace.slugAliases)) aliases.push(...workspace.slugAliases)
  const seen = new Set<string>()
  return aliases.filter((alias) => {
    const key = (alias || '').trim().toLowerCase()
    if (!key || key === current || seen.has(key)) return false
    seen.add(key)
    return true
  })
}
